import { Box, Typography } from '@mui/material'
import React from 'react'

export const PlatformLogin = ({commercialName = '', logo = '', redirectHref = ''}) => {
    const handleClick = () => {
        localStorage.setItem('hasStartLoginWithPlatform', JSON.stringify(true));
        localStorage.removeItem('syncronizeId');
        window.location.href = redirectHref;
    }
    return (
        <Box
            display={'flex'}
            flexDirection={'row'}
            alignContent={'center'}
            justifyContent={'flex-start'}
            alignItems={'center'}
            sx={{
                width: '100%',
                gap: '10px',
                borderRadius: '10px',
                backgroundColor: 'var(--card)',
                padding: '11px 12px',
                cursor: 'pointer',
                border: '1px solid var(--border)',
                boxSizing: 'border-box',
                transition: 'all 0.2s ease-out',
                '&:hover': {
                    backgroundColor: '#E4F7EC',
                    borderColor: '#0DA15A',
                },
            }}
            onClick={handleClick}
        >
            <Box
                component={'img'}
                src={logo}
                sx={{
                    width: '24px',
                    borderRadius: '6px',
                }}
            />
            <Typography variant={'subtitle1'} sx={{ fontSize: '0.9rem', fontWeight: 500, color: 'var(--foreground)' }}>
                Continuar con {commercialName}
                {/* <span style={{color: primaryColor, background: '#61ebac', padding: '5px', borderRadius: '6px'}}>RECOMENDADO</span> */}
            </Typography>
        </Box>
    )
}
